import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import { routes } from 'helpers/router_helper'

const useGuestPostingSequence = () => {
  const history = useHistory()
  const { pathname } = history.location

  const guestSequence = useMemo(() => {
    const isSetUpAccountActive = [
      routes.createProject.redirectUrl(),
      routes.createProjectSuccess.redirectUrl(),
      routes.guestSignUp.redirectUrl(),
    ].includes(pathname)

    const isPostingActive = [routes.createProject.redirectUrl(), routes.createProjectSuccess.redirectUrl()].includes(
      pathname
    )

    const isPostingSucceededActive = [routes.createProjectSuccess.redirectUrl()].includes(pathname)

    return [
      { label: 'SET UP AN ACCOUNT', active: isSetUpAccountActive },
      { label: 'POST YOUR JOB', active: isPostingActive },
      { label: 'INVITE FRIENDS', active: isPostingSucceededActive },
    ]
  }, [pathname])

  return guestSequence
}

export default useGuestPostingSequence
